<template>
  <div>
    <Header></Header>
    <main id="content" role="main">
      <!-- Hero Section -->
      <div class="container space-top-3 space-bottom-2">
        <div class="w-lg-80 text-center mx-lg-auto">
          <div class="mb-5 mb-md-11">
            <h2 class="display-4">{{ uptitle }}</h2>
            <p class="lead">{{ upsubtitle }}</p>
          </div>
        </div>

        <!-- Gallery Section -->
        <div class="row mx-n2">
          <div class="col-6 col-md px-2 mb-3 mb-md-0">
            <div
              v-if="uplist&&uplist.one"
              class="h-250rem bg-img-hero"
              :style="'background-image: url('+imgsrc + uplist.one+');'"
              alt=""
            />
          </div>
          <div class="col-md-4 d-none d-md-block px-2 mb-3 mb-md-0">
            <div
              v-if="uplist&&uplist.two"
              class="h-250rem bg-img-hero"
              :style="'background-image: url('+imgsrc + uplist.two+');'"
              alt=""
            />
          </div>
          <div class="col-6 col-md px-2">
            <div
              v-if="uplist&&uplist.three"
              class="h-250rem bg-img-hero"
              :style="'background-image: url('+imgsrc + uplist.three+');'"
              alt=""
            />
          </div>
        </div>
        <!-- End Gallery Section -->
      </div>
      <!-- End Hero Section -->

      <!-- Divider -->
      <div class="container">
        <div class="w-lg-100 mx-lg-auto">
          <hr class="my-0" />
        </div>
      </div>
      <!-- End Divider -->

      <!-- About Section -->
      <div class="container space-2">
        <div class="row justify-content-lg-between">
          <div class="col-lg-4 mb-4 mb-lg-0">
            <h2>{{ botitle }}</h2>
          </div>
          <div v-if="bocont&&bocont.length>0" class="col-lg-8">
            <p v-html="bocont[0].content"></p>
          </div>
        </div>
      </div>
      <!-- End About Section -->

      <!-- Divider -->
      <div class="container">
        <div class="w-lg-100 mx-lg-auto">
          <hr class="my-0" />
        </div>
      </div>
      <!-- End Divider -->

      <!-- About Section -->
      <div class="container space-2">
        <div class="row justify-content-lg-between">
          <div class="col-lg-4 mb-4 mb-lg-0">
            <h2>{{ usertitle }}</h2>
          </div>
          <div v-if="usercont&&usercont.length>0" class="col-lg-8">
            <p  v-html="usercont[0].content"></p>
          </div>
        </div>
      </div>
      <!-- End About Section -->
      <!-- Divider -->
      <div class="container">
        <div class="w-lg-100 mx-lg-auto">
          <hr class="my-0" />
        </div>
      </div>
      <!-- End Divider -->

      <!-- About Section -->
      <div class="container space-2">
        <div class="row justify-content-lg-between">
          <div class="col-lg-4 mb-4 mb-lg-0">
            <h2>{{ chaotitle }}</h2>
          </div>
          <div v-if="chaocont&&chaocont.length>0" class="col-lg-8">
            <p v-html="chaocont[0].content"></p>
          </div>
        </div>
      </div>
      <!-- End About Section -->
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js"; //1
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js"; //2

import "@/assets/vendor/font-awesome/css/all.min.css"; //12
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css"; //13
import "@/assets/css/theme.css"; //14
import "@/assets/vendor/hs-header/dist/hs-header.min.js"; //4
import "@/assets/vendor/hs-go-to/dist/hs-go-to.min.js"; //5
import "@/assets/vendor/hs-unfold/dist/hs-unfold.min.js"; //6
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js"; //7
import "@/assets/vendor/hs-show-animation/dist/hs-show-animation.min.js"; //8.
import "@/assets/vendor/jquery-validation/dist/jquery.validate.min.js"; //9.
import AOS from "aos";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; //3
import "@/assets/js/hs.core.js"; //10
import "@/assets/js/hs.validation.js"; // 11.

import Header from "../components/header";
import Footer from "../components/footer";
import { getsy, getsycolumn, getsyres } from "../request/index";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      uptitle: "", // 超越标题
      upsubtitle: "", // 超越子标题
      imgsrc: process.env.NODE_URL + "api/files/getFileStream?fileId=",
      uplist: {one:null,two:null,three:null}, // 超越3图
      botitle: "", // 博学标题
      bocont: "", // 博学内容
      usertitle: "", // 用户标题
      usercont: "", // 用户内容
      chaotitle: "", // 超越标题
      chaocont: "", // 超越内容
    }
  },
  created() {
    getsycolumn(0).then(res => {
      let arr = res.data;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].type == '企业文化') {
          getsycolumn(arr[i].columnId).then(res => {
            let arr1 = res.data;
            for (let i = 0; i < arr1.length; i++) {
              if (arr1[i].type == "超越创新探索未来") {
                this.uptitle = arr1[i].title
                this.upsubtitle = arr1[i].subtitle
                this.getimg(arr1[i].columnId)
              }
              if (arr1[i].type == "博学慎思忠信笃行") {
                this.botitle = arr1[i].title
                getsy(arr1[i].columnId).then(res => {
                  
                  this.bocont = res.data.content
                })
              }
              if (arr1[i].type == "用户为本携手共进") {
                this.usertitle = arr1[i].title
                getsy(arr1[i].columnId).then(res => {
                  this.usercont = res.data.content
                })
              }
              if (arr1[i].type == "超越创新,探索未来") {
                this.chaotitle = arr1[i].title
                getsy(arr1[i].columnId).then(res => {
                  console.log(178, res);
                  this.chaocont = res.data.content
                })
              }
            }
          })
        }
      }
    })
  },
  methods: {
    getimg(a) {
      getsy(a).then(res => {
        console.log(171, res);
        let arr = res.data.content;
        this.getzy(arr[0].contentId)
      })
    },
    getzy(a) {
      getsyres(a).then(res => {
        let arr = res.data
        console.log(179,arr);
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].keystring == "超越图一") {this.uplist.one = arr[i].fileId}
          if (arr[i].keystring == "超越图二") {this.uplist.two = arr[i].fileId}
          if (arr[i].keystring == "超越图三") {this.uplist.three = arr[i].fileId}
        }
      })
    }
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    $(document).ready(function () {
      console.log("aaa");
      //   console.log("ccccc",HSHeader)
      //   var header = new HSHeader($("#header")).init();
      console.log("bbb");

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($(".js-mega-menu"), {
        desktop: {
          position: "left",
        },
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold(".js-hs-unfold-invoker").init();

      // initialization of fancybox
      $(".js-fancybox").each(function () {
        var fancybox = $.HSCore.components.HSFancyBox.init($(this));
      });

      // initialization of circles
      $(".js-circle").each(function () {
        var circle = $.HSCore.components.HSCircles.init($(this));
      });

      //initialization of aos
      AOS.init({
        duration: 650,
        once: true,
      });
      // if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) document.write('<script src="@/assets/vendor/polifills.js"><\/script>');
      // initialization of go to
      $(".js-go-to").each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
      $(".js-counter").each(function () {
        var counter = new HSCounter($(this)).init();
      });
    });
  },
};
</script>
<style scoped>

.display-4 {
  font-size: 3.5rem;
  font-weight: 600;
  line-height: 1.2;
}
.lead {
  font-size: 1.25rem;
  font-weight: 400;
  color: #677788;
}
.mb-lg-0 h2 {
  margin-bottom: 0.5rem;
  font-size: 1.875rem;
  font-weight: 600;
  line-height: 1.4;
}
.col-lg-8 p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/view/culture.vue